import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { IQuestionnairesPayload, Questionnaires, QuestionnairesJson } from '../Questionnaires.ts';
import { QuestionnairesApi } from '../../../apis/QuestionnairesApi/QuestionnairesApi.ts';

export function usePostQuestionnaires() {
    const queryClient = useQueryClient();

    return useMutation<number, AppMedError, IQuestionnairesPayload>({
        mutationKey: [QueryKeys.questionnaires, 'create'],
        mutationFn: async (variables: IQuestionnairesPayload) => {
            const newId = await QuestionnairesApi.postQuestionnaires(variables);
            return newId;
        },
        onSuccess: (newId, variables) => {
            // Ajouter le nouveau questionnaire à la liste
            queryClient.setQueryData<Questionnaires[]>(
                [QueryKeys.questionnaires],
                (prev) =>
                    (prev ? [...prev, { ...variables, id: newId }] : [{ ...variables, id: newId }]) as Questionnaires[],
            );

            // Optionnel : stocker aussi le détail immédiatement si nécessaire
            queryClient.setQueryData<QuestionnairesJson>([QueryKeys.questionnaire, newId], { ...variables, id: newId });
        },
    });
}
